import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import news1 from "../../../assets/images/news/news-1.jpg";
import news2 from "../../../assets/images/news/news-2.jpg";
import news3 from "../../../assets/images/news/news-3.jpg";
import { fetchGallery } from '../../../DataFetchers/fetchGallery';


const Gallery = () => {
   
    const [gallery, setGallery] = useState([]);
    useEffect(() => {
        fetchGallery().then((data) => {
            setGallery(data);
        });
    }, []);

    return (
        
        <section className="blog__section see__pad p_relative">
            <div className="auto-container">
                <div className="row">
                    <div className="col-lg-6 col-md-12">
                        <div className="title__data">
                            <div className="title">
                                <h2 className='yellow__text'>Gallery</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {gallery.map((item, id)=>(
                        <div className="col-lg-4 col-md-6 col-sm-12 news__block" key={id}>
                            <div className="news___block wow slideInUp animated animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms">
                                <div className="inner-box p_relative">
                                    <div className="image-box p_relative d_block">
                                        <figure className="gallery image p_relative d_block">
                                            <Link to=""><img src={item.image} alt="" /></Link>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                     ))}
                </div>
            </div>
        </section>
    );
};

export default Gallery;